"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  STYLESHEET_SELECT_MODAL_OPEN: 'stylesheetSelectModalOpen',
  CONTACT_PROPERTY_DEFAULTS_MODAL_OPEN: 'contactPropertyDefaultsModalOpen',
  COMPANY_PROPERTY_DEFAULTS_MODAL_OPEN: 'companyPropertyDefaultsModalOpen',
  OWNER_PROPERTY_DEFAULTS_MODAL_OPEN: 'ownerPropertyDefaultsModalOpen',
  PROPERTY_SEARCH: 'propertySearch',
  SELECTED_PROPERTY: 'selectedProperty'
};
exports.default = _default;
module.exports = exports.default;